import BaseService from '@client.services/baseService';

export default class HealthCheckService extends BaseService {
  async getStatus() {
    return super.api('healthcheck');
  }
}
